// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/pages/index/css/index.css
// module id = 6
// module chunks = 0